import { Box, Heading, Text } from '@wix/design-system'
import React, { FC } from 'react'

import { WixStudioAvatar } from '../../../reusable/WixStudioAvatar'
import { WixStudioSidePanelText } from '../../../reusable/WixStudioSidePanelText'
import { WixStudioTemplateSidePanel } from '../../../reusable/WixStudioTemplate/WixStudioTemplateSidePanel'
import { WixStudioVisual } from '../../../reusable/WixStudioVisual'
// TODO: move this to global hooks
import { useLoadEmail } from '../../WixStudioInvite/useLoadEmail'
import { Card } from './Card'
import s from './SidePanel.scss'
import Site1 from './Site1.svg'
import Site2 from './Site2.svg'
import Site3 from './Site3.svg'
import Team from './Team.svg'

export const SidePanel: FC<{
  heading: string
  role: string
  sitesLabel: string
  membersLabel: string
  membersPlaceholder: string
  members?: string
  memberCircles: number
  text: string
}> = ({ heading, role, sitesLabel, membersLabel, membersPlaceholder, members, memberCircles, text }) => {
  const [emailState] = useLoadEmail()
  const avatar = emailState.type === 'ready' ? { letter: emailState.email[0] } : { loading: true }

  return (
    <WixStudioTemplateSidePanel className={s.root}>
      <WixStudioVisual avatar={avatar} className={s.visual}>
        <Box direction="vertical" margin="25px 15px 0px" overflow="hidden" width="100%" flex="1">
          <Heading size="extraLarge">{heading}</Heading>
          <Box marginTop="8px">
            <Text>{role}</Text>
          </Box>
          <Card margin="20px 0 10px" gap="2px">
            <Team />
            <Box marginLeft="6px" marginRight="auto">
              <Text size="small" weight="normal">
                {membersLabel}
              </Text>
            </Box>
            <Box marginRight="4px">
              <Text size="small" weight="normal" skin={!members ? 'disabled' : undefined}>
                {members || membersPlaceholder}
              </Text>
            </Box>

            {memberCircles >= 5 && <WixStudioAvatar background="#FFF0EA" d="25px" />}
            {memberCircles >= 4 && <WixStudioAvatar background="#D8E2EC" d="25px" />}
            {memberCircles >= 3 && <WixStudioAvatar background="#E2D8FF" d="25px" />}
            {memberCircles >= 2 && <WixStudioAvatar background="#C0E8E8" d="25px" />}
            {memberCircles >= 1 && <WixStudioAvatar background="#DEFF00" d="25px" />}
            {memberCircles === 0 && <WixStudioAvatar background="#ECEFF3" d="25px" />}
          </Card>
          <Card direction="vertical" gap="18px">
            <Box marginTop="4px">
              <Text size="small" weight="normal">
                {sitesLabel}
              </Text>
              <Box marginLeft="auto" height="12px" width="45px" background="#ECEFF3" borderRadius="12px" />
              <Box marginLeft="10px" height="12px" width="45px" background="#ECEFF3" borderRadius="12px" />
            </Box>
            <Box gap="12px">
              <Site1 />
              <Site2 />
              <Site3 />
            </Box>
          </Card>
        </Box>
      </WixStudioVisual>
      <div className={s.text}>
        <WixStudioSidePanelText text={text} />
      </div>
    </WixStudioTemplateSidePanel>
  )
}
